import { useApp } from 'contexts/app';
import { useViewport } from 'contexts/viewport';
import Desktop from 'pages/CreateFormative/desktop';
import Mobile from 'pages/CreateFormative/mobile';
import Tablet from 'pages/CreateFormative/tablet';
import ErrorPage from 'pages/Error/404';
import { useContext } from 'react';
import { Redirect } from 'react-router-dom';
import { Loading } from 'shell/components';
import { PageContext } from './PageProvider';

const PageLayout = () => {
    const { isLoading, assignments, currentAssignmentId, currentAssignment, formative } = useApp();
    const { device } = useViewport();

    const contextProps = useContext(PageContext);

    const props = { ...contextProps };

    const renderResponsiveLayout = (device) => {
        return {
            mobile: <Mobile {...props} />,
            tablet: <Tablet {...props} />,
            desktop: <Desktop {...props} />,
        }[device];
    };

    if (isLoading || !contextProps.form) return <Loading />;

    if (formative) return <Redirect to={`/assignments/${currentAssignmentId}/submissions`} />;

    if (assignments && !currentAssignment) return <ErrorPage />;

    return <>{renderResponsiveLayout(device)}</>;
};

export default PageLayout;
